(() => {
  const normalize = (text) => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/(\d),(?=\d)/g, '$1').toLowerCase().trim();
  const initialize = (scope) => {
    const roots = scope.matches?.('[data-lc-support]') ? [scope] : scope.querySelectorAll('[data-lc-support]');
    roots.forEach((root) => {
      if (root.dataset.supportReady) return;
      root.dataset.supportReady = 'true';
      const input = root.querySelector('[data-faq-search]');
      const buttons = [...root.querySelectorAll('[data-faq-category]')];
      const items = [...root.querySelectorAll('[data-faq-item]')];
      const empty = root.querySelector('[data-faq-empty]');
      const status = root.querySelector('[data-faq-result-status]');
      const categories = new Set(['artwork', 'ordering', 'materials', 'application', 'reorders', ...buttons.map((button) => button.dataset.faqCategory), ...items.map((item) => item.dataset.category)]);
      const categoryFromHash = () => {
        const hash = window.location.hash.slice(1).toLowerCase();
        if (hash === 'artwork-guidelines') return 'artwork';
        if (hash === 'all' || hash === 'faqs' || hash === '') return 'all';
        return categories.has(hash) ? hash : null;
      };
      let category = categoryFromHash() || 'all';
      const updateHash = () => {
        const nextHash = category === 'all' ? '' : `#${category}`;
        window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}${nextHash}`);
      };
      const filter = () => {
        const query = normalize(input?.value);
        const terms = query.split(/\s+/).filter(Boolean);
        let shown = 0;
        items.forEach((item) => {
          const content = normalize(item.textContent);
          const matches = (category === 'all' || item.dataset.category === category) && terms.every((term) => content.includes(term));
          item.hidden = !matches;
          if (matches) shown += 1;
        });
        buttons.forEach((button) => {
          const active = button.dataset.faqCategory === category;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (empty) empty.hidden = shown > 0;
        if (status) {
          status.hidden = !query && category === 'all';
          const answer = shown === 1 ? root.dataset.answerSingular : root.dataset.answerPlural;
          status.textContent = String(root.dataset.resultFormat || '').replaceAll('[count]', String(shown)).replaceAll('[answers]', answer || '');
        }
      };
      input?.addEventListener('input', filter);
      buttons.forEach((button) => button.addEventListener('click', () => {
        category = button.dataset.faqCategory;
        filter();
        updateHash();
      }));
      root.querySelectorAll('[data-faq-reset]').forEach((reset) => reset.addEventListener('click', () => {
        category = 'all';
        if (input) input.value = '';
        filter();
        updateHash();
        input?.focus();
      }));
      const topic = root.querySelector('[data-contact-topic]');
      const artworkField = root.querySelector('[data-artwork-link-field]');
      const artworkInput = root.querySelector('[name="contact[Artwork link]"]');
      const submit = root.querySelector('[data-contact-submit]');
      const setTopic = () => {
        if (!topic) return;
        const artwork = topic.value === 'Artwork help';
        if (artworkField) artworkField.hidden = !artwork;
        if (artworkInput) artworkInput.disabled = !artwork;
        if (submit) submit.textContent = (artwork ? root.dataset.artworkSubmit : root.dataset.generalSubmit) || '';
      };
      topic?.addEventListener('change', setTopic);
      root.querySelectorAll('[data-contact-link]').forEach((link) => link.addEventListener('click', () => {
        if (!topic) return;
        topic.value = 'Other';
        setTopic();
        requestAnimationFrame(() => (root.querySelector('[name="contact[name]"]') || root.querySelector('[name="contact[email]"]'))?.focus({ preventScroll: true }));
      }));
      const queryTopic = new URLSearchParams(window.location.search).get('topic');
      if (queryTopic === 'artwork' && topic) topic.value = 'Artwork help';
      const applyHash = () => {
        const nextCategory = categoryFromHash();
        if (nextCategory !== null) {
          category = nextCategory;
          if (input) input.value = '';
          filter();
          if (category !== 'all') {
            const firstMatch = items.find((item) => item.dataset.category === category);
            if (firstMatch) firstMatch.open = true;
          }
        }
        if (window.location.hash.toLowerCase() === '#artwork-help' && topic) {
          topic.value = 'Artwork help';
          setTopic();
        }
      };
      window.addEventListener('hashchange', applyHash);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) window.removeEventListener('hashchange', applyHash);
      });
      setTopic();
      filter();
      applyHash();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
